module.exports = __webpack_public_path__ + "static/WillBud-folder-OJPIII-WWW_pages-to-jpg-0010-820f303836a99f181e2317f07edfd76b.jpg";